import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-back-button',
  templateUrl: './back-button.component.html',
  styleUrl: './back-button.component.scss'
})
export class BackButtonComponent implements OnInit {

  @Input() routerLink?: string[];
  @Input() linkText = '';
  @Input() direction: 'forward' | 'back' = 'back';

  iconUrl = '../../assets/icon/back.svg';

  ngOnInit() {
    if (this.direction === 'forward') {
      this.iconUrl = '../../assets/icon/forward.svg';
    }
  }

}
